export default __webpack_public_path__ + "badminton-live.png";